


































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { TriggeredAction } from '@/api/model/triggered-action'
import { cloneDeep, isEqual } from 'lodash'
import { Pipeline } from '@/api/model/pipeline'
import { PipelineAPI } from '@/api/backend-client'
import { availableReferralOrigins } from '@/api/types'

@Component
export default class CreateAutoActionFormStep1 extends Vue {
    @Prop({ required: true }) readonly value!: TriggeredAction
    editingValue: TriggeredAction = null
    triggerType: string = null
    referralPipelines: Pipeline[] = []
    loadingPipelines: boolean = true

    @Watch('value', { immediate: true })
    onValueChanged() {
        this.editingValue = cloneDeep(this.value)
        if (!this.triggerType) {
            this.triggerType = this.editingValue.triggerType
        }
    }

    @Watch('editingValue.referralOrigin')
    @Watch('editingValue.referralPipeline')
    onEditingValueChanged() {
        if (isEqual(this.editingValue, this.value)) {
            return
        }

        this.$emit('update:value', this.editingValue)
    }

    mounted() {
        this.loadPipelines()
    }

    async loadPipelines(): Promise<void> {
        this.loadingPipelines = true
        this.referralPipelines = await PipelineAPI.getAll({ company: this.$currentCompany.id })
        this.loadingPipelines = false
    }

    get availableReferralOrigins() {
        return availableReferralOrigins().map(referralOrigin => ({
            label: this.$t('forms.triggered_action_form.origin_options.' + referralOrigin),
            value: referralOrigin,
        }))
    }

    get availableReferralPipelines(): Pipeline[] {
        return this.referralPipelines
            .filter(pipeline => pipeline.active)
            .sort((a, b) => a.name.localeCompare(b.name))
    }

    get pipelineLabel() {
        const values = {
            referral: '',
        }

        if (this.editingValue.referralOrigin === 'external') {
            values.referral = 'externe'
        } else if (this.editingValue.referralOrigin === 'internal') {
            values.referral = 'interne'
        } else  {
            values.referral = 'externe en interne'
        }

        return this.$t('virtualColleague.autoAction.pipelineLabel', values)
    }
}
